import { TransferData } from "../models/Transfer";
import { api } from "../services/Api";
import { filterAndPageableToRequest } from "../utils/filterAndPageableToRequest";

export function useTransfer() {
  const baseUrl = "/transfers";
  const baseUrlBarteBalance = "/backoffice/v1/transfers/balance";

  const getTansfers = async (filter: object, pageable: object) => {
    return await api.get(`${baseUrl}${filterAndPageableToRequest({ filter, pageable })}`);
  }

  const postTransfer = async (transferData: TransferData) => {
    return await api.post(`${baseUrl}`, transferData);
  }

  const getTransferStatement = async (filter: object, pageable: object) => {
    return await api.get(`${baseUrl}/statement${filterAndPageableToRequest({ filter, pageable })}`);
  }

  const getBarteBalance = async () => {
    return await api.get(`${baseUrlBarteBalance}`);
  }

  const deleteAuthorize = async (uuid: string) => {
    return await api.delete(`${baseUrl}/${uuid}`);
  }

  const getToDoTransfers = async (filter: object, pageable: object) => {
    return await api.get(`${baseUrl}/balances${filterAndPageableToRequest({ filter, pageable })}`);
  }

  const postToDoTransfers = async (sellerId: string, data) => {
    return await api.post(`${baseUrl}/${sellerId}`, data);
  }

  const getToAuthorize = async (filter: object, pageable: object) => {
    return await api.get(`${baseUrl}/authorize${filterAndPageableToRequest({ filter, pageable })}`);
  }

  const getLastApproved = async (filter: object, pageable: object) => {
    return await api.get(`${baseUrl}/approved${filterAndPageableToRequest({ filter, pageable })}`);
  }

  const authorizeBatch = async (data: any) => { 
    return await api.post(`${baseUrl}/authorize`, data);
  }

  return {
    getTansfers,
    postTransfer,
    getTransferStatement,
    getToDoTransfers,
    postToDoTransfers,
    getToAuthorize,
    getBarteBalance,
    deleteAuthorize,
    getLastApproved,
    authorizeBatch
  }
}
